import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiServiceDelegate } from './api-service-delegate';
import { environment } from '../../../environments/environment';
import { AppCommon } from '../app-common';

@Injectable()
export class ApiService {

    url = environment.api_url;

    constructor(private http: HttpClient) { }

    // this method is provided to client classes to call api
    callService(data: ApiServiceDelegate) {
        var newURL = this.url + data.Action;
        this.execute(data.Data, newURL, data.Method).subscribe(
        (result: any) => {
            let res = result.res;
            data.Success(res);
        },
        (error: any) => {
            if (typeof error['Errors'] !== 'undefined') {
            data.Error(error['Errors']);
            }
        }
        );
    }

    execute(apiData: any, url: string, method: String) {
      if (method == 'POST') {
        return this.http.post(url, apiData, this.getHeaderOptions()).pipe(map((res: Response) => {return { res: res };})).pipe(catchError(this.errorHandler));
      } else if (method == 'DELETE') {
        return this.http.delete(url, this.getHeaderOptions()).pipe(map((res: Response) => {return { res: res };})).pipe(catchError(this.errorHandler));
      } else if (method == 'PATCH') {
        return this.http.patch(url, apiData, this.getHeaderOptions()).pipe(map((res: Response) => {return { res: res }; })).pipe(catchError(this.errorHandler));
      } else if (method == 'PUT') {
        return this.http.put(url, apiData, this.getHeaderOptions()).pipe(map((res: Response) => {return { res: res }; })).pipe(catchError(this.errorHandler));
      } else {
        return this.http.get(url, this.getHeaderOptions()).pipe(map((res: Response) => {return { res: res };})).pipe(catchError(this.errorHandler));
      }
    } 

    executeWithResponse(apiData: any, url: string, method: String) {
      const httpOptions = {
        ...this.getHeaderOptions(),
        observe: 'response' as const
      };
      if (method == 'POST') {
        return this.http.post(url, apiData, httpOptions);
      }
      return this.http.get(url, httpOptions);
    }

    getHeaderOptions() {
        let httpHeaders = new HttpHeaders();
        httpHeaders = httpHeaders.set('Content-Type', 'application/json');        
        const loggedObject = AppCommon.getloggedInObject();
        const token = AppCommon.getloggedInObject()?.token;
        if (loggedObject && token){
          httpHeaders = httpHeaders.set("Authorization", "Bearer " + token);
        } 
        const httpOptions = {
          headers: httpHeaders
        };
        return httpOptions;
    }
 
    errorHandler(e: any) {
        return throwError({ Errors: e.error });
    }

    uploadFile(url: string, formData: FormData, headers: HttpHeaders){
      var newURL = this.url + url;
      
      const loggedObject = AppCommon.getloggedInObject();
      const token = AppCommon.getloggedInObject()?.token;
      if (loggedObject && token){
        headers = headers.set("Authorization", "Bearer " + token);
      } 
      const httpOptions = {
        headers: headers,
      };
      return this.http.post(newURL, formData, httpOptions).pipe(
        map((res: Response) => {
          return { res: res };
        })
      )
      .pipe(catchError(this.errorHandler));
    }

    downloadFile(url, headers: HttpHeaders){
      var newURL = this.url + url;
      var httpOptions = {
        headers: headers,
        observe: "response" as "body",
        responseType: "blob" as "json"
      }
      return this.http.get(newURL, httpOptions).pipe(
        map((res: Response) => {
          return { res: res };
        })
      )
      .pipe(catchError(this.errorHandler));
    }

    download(url) { 
      var newURL = this.url + url;
      let httpHeaders = new HttpHeaders();
      httpHeaders.append("Accept", "application/json");
      if (AppCommon.getloggedInObject() && AppCommon.getloggedInObject().token)
        httpHeaders = httpHeaders.set(
          "Authorization",
          "Bearer " + AppCommon.getloggedInObject().token,
        );
      var HTTPOptions = {
        headers: httpHeaders,
        observe: "response" as "body", // to display the full response & as 'body' for type cast
        responseType: "blob" as "json",
      };
      return this.http
        .get(newURL, HTTPOptions)
        .pipe(catchError(this.errorHandler));
    }

    patchUploadFile(url: string, formData: FormData, headers: HttpHeaders){
      var newURL = this.url + url;
      
      const loggedObject = AppCommon.getloggedInObject();
      const token = AppCommon.getloggedInObject()?.token;
      if (loggedObject && token){
        headers = headers.set("Authorization", "Bearer " + token);
      } 
      const httpOptions = {
        headers: headers,
      };
      return this.http.patch(newURL, formData, httpOptions).pipe(
        map((res: Response) => {
          return { res: res };
        })
      )
      .pipe(catchError(this.errorHandler));
    }
    


}
